



















































import { Vue, Component } from 'vue-property-decorator';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  ColGroupDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { fetchData } from '@/pantallas/AsignacionMultiFlota/fetchData';
import moment from 'moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import VerDetalleModal from '@/pantallas/AsignacionMultiFlota/VerDetalleModal.vue';

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    DatePicker,
    VerDetalleModal,
  },
})
export default class InformesGenerados extends Vue {
  loadingService = new LoadingService();

  formsFields: {
    fechaDesde: { id: string; label: string; value: any };
    fechaHasta: { id: string; label: string; value: any };
  } = {
    fechaDesde: {
      id: '1110',
      label: 'Desde',
      value: moment(new Date()).add(-1, 'months'),
    },
    fechaHasta: {
      id: '1111',
      label: 'Hasta',
      value: moment(new Date()),
    },
  };
  formSend: { fechaDesde: any; fechaHasta: any } = {
    fechaDesde: moment(new Date()).add(-1, 'months'),
    fechaHasta: moment(new Date()),
  };
  currentDates: { fechaDesde: any; fechaHasta: any } = {
    fechaDesde: '',
    fechaHasta: '',
  };
  datesHasChange: boolean = false;

  gridOptions: GridOptions;
  localeText: any = {};
  sideBar: any = {};
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef | ColGroupDef> = [];
  agGridUtil: AgGridUtil;
  searchReport: string = '';
  timer: any = '';
  serverSide: any;
  showInfoDialog: boolean = false;
  infoItems: any[] = [];
  infoTypeReport: string = '';
  showButtonInformes: boolean = false;
  mostrarModalVerDetalle: boolean = false;
  detalleSeleccionado: any = [];

  mounted() {
    this.showButtonInformes =
      this.$route.path == '/Torre-Control/informes_generados';
  }
  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'cliente_origen_id',
        field: 'cliente_origen_id',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
        hide: true,
      },
      {
        headerName: 'Cliente Origen',
        field: 'cliente_origen',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'cliente_multiflota_id',
        field: 'cliente_multiflota_id',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
        hide: true,
      },
      {
        headerName: 'Cliente Destino',
        field: 'cliente_multiflota',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Flota Origen',
        field: 'flota_origen',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Flota Destino',
        field: 'flota_destino',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Patente',
        field: 'patente_vehiculo',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Resultado',
        field: 'data_resultado',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Imei',
        field: 'imei',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Serie',
        field: 'serie',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Sim',
        field: 'sim',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
      },
      {
        headerName: 'Fecha de creación',
        field: 'fecha_creacion',
        sortable: true,
        resizable: true,
        minWidth: 80,
        width: 130,
        sort: 'desc',
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 50, //Solución Paginación //Ordenamiento + Selección
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCellSelection: false,
      localeText: this.localeText,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onCellClicked: this.downloadFile,
      onGridReady: this.onGridReady,
      columnDefs: this.columnDefs,
      suppressCopyRowsToClipboard: true,
      //   onSelectionChanged: this.onSelectionChanged,
      //   onRowSelected: this.onSelectionRow,
      isExternalFilterPresent: this.isExternalFilterPresent,
      doesExternalFilterPass: this.doesExternalFilterPass,
      blockLoadDebounceMillis: 350,
      //   onDragStopped: this.onDragStoppedEvent,
      //   onColumnPinned: this.onColumnPinnedEvent,
      columnTypes: {
        medalColumn: { width: 150, columnGroupShow: 'open', filter: false },
        // fecha: {
        //   cellRenderer: this.fechaFilter,
        //   sortable: true,
        //   resizable: true,
        //   filter: false,
        // },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
    };
  }

  validateDates() {
    // if (
    //   this.currentDates.fechaDesde != '' ||
    //   this.currentDates.fechaHasta != ''
    // ) {
    //   if (
    //     !this.currentDates.fechaDesde.isSame(
    //       this.formsFields.fechaDesde.value
    //     ) ||
    //     !this.currentDates.fechaHasta.isSame(this.formsFields.fechaHasta.value)
    //   ) {
    //     this.datesHasChange = false;
    //   } else {
    //     this.datesHasChange = true;
    //   }
    // }
  }

  downloadFile(event: any) {
    if (event.colDef.headerName == 'Descarga' && event.data.activo == 't') {
      var tk = event.data.token;
      let _url_base = process.env.VUE_APP_SERVICIO_MS;
      window.open(_url_base + 'descarga_reporte?tk=' + tk, '_blank');
    }
  }

  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
    setTimeout(() => {
      this.actualizaGrilla();
    }, 1000);
    // this.onGridReady()
  }

  // Computed
  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  get today() {
    return moment(new Date());
  }

  get semanaAnterior() {
    let fechaMin = moment(new Date()).add(-7, 'days');
    return fechaMin;
  }

  handleClickInfo(event: any) {
    var itemsInfo: any[] = [];
    if (event.value != '' && event.value != undefined && event.value != null) {
      for (var key in event.value) {
        if (event.value.hasOwnProperty(key)) {
          itemsInfo.push({ key: key, value: event.value[key] });
        }
      }
    }
    this.infoItems = itemsInfo;
    this.infoTypeReport = event.data.nombre_reporte;
    this.showInfoDialog = true;
  }

  async intervalSearchReports() {
    this.loadingService.showLoading();
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  // isTokenOK(date: any) {
  //   let token = moment(new Date('DD-MM-YYYY HH:MM:SS')).add(-5, 'days');
  //   let today = moment(date,'DD-MM-YYYY HH:MM:SS');
  //   if (token.isAfter(today)) {
  //     return false; //se cambia a false para que nunca expire
  //   } else {
  //     return true;
  //   }
  // }

  getHtml(params: any): string {
    var css = '';
    if (params.data.activo == 'f') {
      params.data.estado = 'ARCHIVO EXPIRADO';
      css =
        '<i class="material-icons" id="5545" title="Archivo Expirado" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    } else if (params.data.estado == 'TERMINADO') {
      css =
        '<i class="material-icons" id="5545" title="Terminado" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;" ></i>';
    } else if (
      params.data.estado == 'PENDIENTE' ||
      params.data.estado == 'EN_PROCESO'
    ) {
      css =
        '<i class="material-icons" id="5545" title="Pendiente" style="width: 24px; height: 24px; margin-top: 7%; background: #FFF226; border-radius: 50%;"></i>';
    } else if (params.data.estado == 'FALLA') {
      css =
        '<i class="material-icons" id="5545" title="Error" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;" ></i>';
    }
    if (
      params.data.is_programmed == 'true' &&
      params.data.estado == 'PENDIENTE'
    ) {
      css =
        '<i class="material-icons" id="5545" title="Pendiente" style="width: 24px; height: 24px; margin-top: 7%; background: rgb(39, 72, 142); border-radius: 50%;"></i>';
      return (
        css +
        '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
        'Programado' +
        '</a>'
      );
    }
    return (
      css +
      '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
      params.data.estado +
      '</a>'
    );
  }

  verModal() {
    this.mostrarModalVerDetalle = true;
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    const self = this;
    // this.startInterval();
    this.loadingService.showLoading();
    this.serverSide = {
      getRows(params: any): void {
        // clearInterval(self.timer);
        var start_date = moment(self.formsFields.fechaDesde.value.toString())
          .format('YYYY-MM-DD')
          .toString();
        var ending_date = moment(self.formsFields.fechaHasta.value.toString())
          .format('YYYY-MM-DD')
          .toString();
        params.request.search = self.searchReport;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        var body = Object.assign({}, params.request, {
          id_cliente: self.getClientID(),
          start_date: start_date,
          ending_date: ending_date,
          id_usuario: self.getUserID(),
          pathname: window.location.pathname,
        });
        fetchData(body, 'integracion_multiflota/getGrillaDetalle')
          .then((response: any) => {
            if (response.data.MENSAJE_RESPUESTA == 'OK') {
              params.successCallback(response.data.data, response.data.len);
              self.autoSizeAll(false);
              self.gridApi.hideOverlay();
            } else {
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
            }
            //self.gridApi.sizeColumnsToFit();
            self.loadingService.hideLoading();
          })
          .catch((error: any) => {})
          .finally(() => {
            // self.startInterval();
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading();
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  async actualizaGrilla() {
    const self = this;
    this.loadingService.showLoading();
    this.serverSide = {
      getRows(params: any): void {
        // clearInterval(self.timer);
        var start_date = moment(self.formsFields.fechaDesde.value.toString())
          .format('YYYY-MM-DD')
          .toString();
        var ending_date = moment(self.formsFields.fechaHasta.value.toString())
          .format('YYYY-MM-DD')
          .toString();
        params.request.search = self.searchReport;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        var body = Object.assign({}, params.request, {
          id_cliente: self.getClientID(),
          start_date: start_date,
          ending_date: ending_date,
          id_usuario: self.getUserID(),
          pathname: window.location.pathname,
        });
        fetchData(body, 'integracion_multiflota/getGrillaDetalle')
          .then((response: any) => {
            if (response.data.MENSAJE_RESPUESTA == 'OK') {
              params.successCallback(
                response.data.data,
                response.data.data.length
              );
              self.autoSizeAll(false);
              self.gridApi.hideOverlay();
            } else {
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
            }
            //self.gridApi.sizeColumnsToFit();
            self.loadingService.hideLoading();
          })
          .catch((error: any) => {})
          .finally(() => {
            // self.startInterval();
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading();
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  startInterval() {
    var self = this;
    this.timer = setInterval(function() {
      self.gridApi.setServerSideDatasource(self.serverSide);
    }, 20000);
  }

  isExternalFilterPresent(): boolean {
    return true;
  }

  doesExternalFilterPass(node: RowNode): boolean {
    return true;
  }

  handleSearch(event: string) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }

  handleModal() {
    this.loadingService.showLoading();
    this.$router.push('/Torre-Control/generar_informe');
  }
}
